import React from 'react';
import { AlignLeft } from 'lucide-react';

/**
 * Компонент для настройки формата вывода результатов
 */
const OutputFormatSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="mb-6">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <AlignLeft className="w-5 h-5 mr-2 text-indigo-500" />
        Формат вывода
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {/* Выбор формата разделения */}
        <label className="flex flex-col bg-gray-50 dark:bg-gray-700/30 rounded-lg p-3 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700/50 cursor-pointer">
          <div className="flex items-center">
            <input
              type="radio"
              name="format"
              value="comma"
              checked={formData.format === 'comma'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Через запятую
            </span>
          </div>
          <div className="mt-2 text-xs text-gray-500 dark:text-gray-400 font-mono bg-white dark:bg-gray-800 p-2 rounded">
            1, 2, 3, 4, 5
          </div>
        </label>

        <label className="flex flex-col bg-gray-50 dark:bg-gray-700/30 rounded-lg p-3 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700/50 cursor-pointer">
          <div className="flex items-center">
            <input
              type="radio"
              name="format"
              value="space"
              checked={formData.format === 'space'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              Через пробел
            </span>
          </div>
          <div className="mt-2 text-xs text-gray-500 dark:text-gray-400 font-mono bg-white dark:bg-gray-800 p-2 rounded">
            1 2 3 4 5
          </div>
        </label>

        <label className="flex flex-col bg-gray-50 dark:bg-gray-700/30 rounded-lg p-3 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700/50 cursor-pointer">
          <div className="flex items-center">
            <input
              type="radio"
              name="format"
              value="newline"
              checked={formData.format === 'newline'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              По одному в строке
            </span>
          </div>
          <div className="mt-2 text-xs text-gray-500 dark:text-gray-400 font-mono bg-white dark:bg-gray-800 p-2 rounded whitespace-pre">
            1<br/>2<br/>3<br/>...
          </div>
        </label>
      </div>
    </div>
  );
};

export default OutputFormatSection;